module.exports = __webpack_public_path__ + "img/넷플릭스가격.d9168d7f.png";